import { DataLayer } from '@/shared/services/gtm/models/models-gtm'

export class FilmDetailsViewDataLayer extends DataLayer {
    public movie_id: string
    public film_name: string
    public genre: string
    public technology: string
    public cinema: string

    public constructor(params: {
        movie_id: string
        filmName: string
        genre: string
        technology: string
        cinema: string
        uniqueEventId?: number
        element?: string
        customerId?: string | null
    }) {
        super('movie_detail_page', params.uniqueEventId, params.element)
        this.movie_id = params.movie_id
        this.film_name = params.filmName
        this.genre = params.genre
        this.technology = params.technology
        this.cinema = params.cinema
        this.customerId = params.customerId
    }
}
